import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";
import { useAuth } from "../contexts/AuthContext";

export default function Main() {
  const { user } = useAuth();
  const offsets = ["/apps/file-manager", "/apps/email", "/apps/calendar"];
  const { pathname } = useLocation();
  const bc = document.body.classList;

  // set sidebar to offset
  (offsets.includes(pathname)) ? bc.add("sidebar-offset") : bc.remove("sidebar-offset");

  // auto close sidebar when switching pages in mobile
  bc.remove("sidebar-show");

  // scroll to top when switching pages
  window.scrollTo(0, 0);

  return (
    <React.Fragment>
      {/* Header en haut de la page */}
      <Header />
      
      {/* Sidebar et contenu principal */}
      <Sidebar user={user} />
      <div className="main main-app p-3 p-lg-4">
        <div className="container-fluid">
          <Outlet />

          
        </div>
        {/* Footer en bas de la page */}
        <Footer />
      </div>
      
    </React.Fragment>
  );
}